import { z } from 'zod';
import { validatePhoneNumber } from '../helpers/country-calling-codes.js';
import { normalizePhoneNumber } from '../helpers/normalize-phone-number.js';
export const BUYER_PHONE_INVALID_MESSAGE = 'Numéro de téléphone invalide (format attendu : 0X XX XX XX XX).';
/**
 * Règle de validation partagée (front + back) du numéro de téléphone acheteur.
 *
 * Vit dans une fonction pure pour être réutilisable quelle que soit la version
 * de zod (le front `informations` est en zod/v4, les contracts en zod classique).
 * On normalise le format saisi (0X…, +33…, 0033…, avec espaces) vers
 * +{indicatif}{NSN} puis on valide la longueur nationale.
 *
 * Rejette p.ex. "6712131412" (10 chiffres sans 0 initial), que SSP refuse avec
 * FORM_006 « consumer_phone_number is incorrect ».
 */
export function isValidBuyerPhone(value) {
    return validatePhoneNumber(normalizePhoneNumber(value)) === undefined;
}
export const buyerPhoneSchema = z
    .string()
    .trim()
    .min(1, 'Le numéro de téléphone est requis.')
    .refine(isValidBuyerPhone, BUYER_PHONE_INVALID_MESSAGE);
